<template>
  <div>
    <!-- Legenda do sistema de cores -->
    <v-card class="mb-4 pa-3" outlined>
      <v-row align="center" no-gutters>
        <v-col>
          <div class="text-body-2 mb-2">
            <strong>Descrição das cores das evidências:</strong>
          </div>
          <div class="d-flex flex-wrap" style="gap: 12px">
            <div
              v-for="(label, chave) in {
                '15/05': 'Prazo até 15/05, 18h (Horário de Brasília)',
                '15/06': 'Prazo até 15/06, 18h (Horário de Brasília)',
                '14/08': 'Prazo até 14/08, 18h (Horário de Brasília)',
                '04/09': 'Prazo até 04/09, 18h (Horário de Brasília)',
                expirado: 'Prazo expirado',
              }"
              :key="chave"
              class="d-flex align-center"
            >
              <div
                :style="{
                  width: '14px',
                  height: '14px',
                  background: CORES_PRAZO[chave].border,
                  borderRadius: '3px',
                }"
                class="mr-2"
              ></div>
              <span
                class="text-caption"
                v-html="label.replace(/(\d{2}\/\d{2})/, '<strong>$1</strong>')"
              ></span>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>

    <v-data-table
      :headers="visualizarPontosMedalha ? headers : headersSemPontos"
      :items="perguntasRespondidas1"
      class="respo elevation-1"
      hide-default-footer
      disable-pagination
      :expanded.sync="expanded"
      item-key="perguntaMunicipioId"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:item="props">
        <!-- Aviso compacto de data limite de envio -->
        <tr v-if="props.item.dataLimiteEnvio" class="data-limite-row">
          <td colspan="7" style="padding: 8px 0px 0px 0px; border: none">
            <div
              class="d-flex align-center pa-2 rounded"
              :style="getPrazoHeaderStyle(props.item.dataLimiteEnvio)"
            >
              <v-icon
                small
                :color="getPrazoIconColor(props.item.dataLimiteEnvio)"
                class="mr-2"
              >
                {{
                  isDataLimiteVencida(props.item.dataLimiteEnvio)
                    ? "mdi-alert-circle"
                    : "mdi-clock-alert-outline"
                }}
              </v-icon>
              <span class="text-body-2">
                <strong
                  >{{
                    isDataLimiteVencida(props.item.dataLimiteEnvio)
                      ? "Prazo expirado"
                      : "Prazo"
                  }}:</strong
                >
                {{ formatarDataLimite(props.item.dataLimiteEnvio) }} (Horário de
                Brasília)
              </span>

              <div v-if="!consultaSomenteLeitura(props.item) && (podeAlterarPrazoEnvioEvidencias)" class="ml-2">
                <div
                  v-if="itemAlteracaoData === props.item.perguntaMunicipioId"
                  class="d-inline-flex align-center"
                >
                  <v-text-field
                    v-model="novaDataLimite"
                    type="date"
                    dense
                    outlined
                    hide-details
                    class="mr-2"
                    placeholder="Selecione a data"
                  ></v-text-field>
                  <v-text-field
                    value="18:00"
                    type="time"
                    dense
                    outlined
                    hide-details
                    prepend-inner-icon="mdi-clock-outline"
                    style="width: 120px"
                    class="mr-2"
                    disabled
                    placeholder="HH:MM"
                  ></v-text-field>
                  <v-btn
                    small
                    color="success"
                    @click="alterarDataLimite(props.item)"
                    :loading="salvandoNovaData"
                    :disabled="!novaDataLimite || !novaHoraLimite"
                    class="mr-1"
                   v-if="!consultaSomenteLeitura(props.item)">
                    <v-icon small>mdi-check</v-icon>
                  </v-btn>
                  <v-btn small outlined @click="itemAlteracaoData = null">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-btn
                  v-else
                  small
                  outlined
                  color="primary"
                  @click="abrirAlteracaoData(props.item)"
                 v-if="!consultaSomenteLeitura(props.item)">
                  <v-icon small class="mr-1">mdi-pencil</v-icon>
                  Alterar prazo
                </v-btn>
              </div>

              <!-- Aviso sobre prazo da declaração -->
              <template
                v-if="
                  props.item.perguntaId == 3 &&
                  props.item.dataLimiteEnvioDeclaracao
                "
              >
                <v-divider vertical class="mx-2"></v-divider>
                <v-icon
                  small
                  :color="isPrazoVencido(props.item, true) ? 'warning' : 'info'"
                  class="mr-1"
                >
                  {{
                    isPrazoVencido(props.item, true)
                      ? "mdi-alert-circle"
                      : "mdi-information"
                  }}
                </v-icon>
                <span
                  class="text-body-2"
                  :style="`color: ${
                    isPrazoVencido(props.item, true) ? '#ff8f00' : '#1976d2'
                  }`"
                >
                  <strong>Prazo para envio da declaração:</strong>
                  {{ formatarDataLimite(props.item.dataLimiteEnvioDeclaracao) }}
                  (Horário de Brasília)
                  <v-chip
                    v-if="isPrazoVencido(props.item, true)"
                    color="warning"
                    x-small
                    class="ml-1"
                  >
                    EXPIRADO
                  </v-chip>
                </span>
              </template>
            </div>
          </td>
        </tr>

        <tr
          :class="getPrazoRowClass(props.item.dataLimiteEnvio)"
          :style="getPrazoRowStyle(props.item.dataLimiteEnvio)"
        >
          <td>{{ props.item.nome }}</td>
          <td>
            <div>
              <div>
                {{ props.item.texto }}
              </div>
            </div>
          </td>

          <td
            v-if="
              props.item.perguntaId == 16 ||
              props.item.perguntaId == 17 ||
              props.item.perguntaId == 23
            "
            style="text-align: center; width: 150px"
          >
            <div>N. Atendentes</div>
            <div style="font-weight: bold; font-size: 16px">
              {{ valorDiagnosticoPergunta3 == null ? "—" : valorDiagnosticoPergunta3 }}
            </div>
            <div class="text-caption">{{ origemAtendentesProdutividade }}</div>
            <v-btn
              v-if="props.item.temArquivo"
              color="azulclarosc"
              class="mt-2"
              :style="{ color: '#fff', fontSize: '12px' }"
              @click="
                () => {
                  $emit('openEvidence', props.item);
                  verComplemento = !verComplemento;
                }
              "
            >
              {{
                expanded.length > 0 &&
                props.item.perguntaMunicipioId === expanded[0].perguntaMunicipioId
                  ? "esconder arquivos"
                  : "mostrar arquivos"
              }}
            </v-btn>
          </td>
          <td
            @click="
              () => {
                $emit('openEvidence', props.item);
                verComplemento = !verComplemento;
              }
            "
            v-else-if="
              props.item.temArquivo || (isSala && props.item.perguntaId == 3)
            "
          >
            <div class="optionsExpanded">
              <v-btn
                color="azulclarosc"
                class="ml-3"
                :style="{
                  color: '#fff',
                  fontSize:
                    isSala && props.item.perguntaId == 3 ? '9px' : '12px',
                }"
              >
                <span
                  v-if="
                    expanded.length > 0 &&
                    props.item.perguntaMunicipioId ===
                      expanded[0].perguntaMunicipioId
                  "
                  >esconder arquivos<span
                    v-if="isSala && props.item.perguntaId == 3"
                    >/declaração</span
                  ></span
                >
                <span v-else
                  >mostrar arquivos<span
                    v-if="isSala && props.item.perguntaId == 3"
                    >/declaração</span
                  ></span
                >
              </v-btn>
            </div>
          </td>
          <td v-else></td>
          <td width="300px">
            <v-form
              ref="file"
              lazy-validation
              v-if="
                podeEnviarPergunta1(props.item) &&
                !isDataLimiteVencida(props.item.dataLimiteEnvio) &&
                (isFullAdmin ||
                  !isSala ||
                  (isSala &&
                    JSON.parse(config.visualizaEixosIds || '[]').includes(
                      props.item.eixoId
                    )))
              "
            >
              <v-file-input
                :accept="getFileAccept(props.item.perguntaId)"
                v-if="!consultaSomenteLeitura(props.item) && (
                  podeEnviarPergunta1(props.item) &&
                  !isDataLimiteVencida(props.item.dataLimiteEnvio) &&
                  (isFullAdmin ||
                    (groupsConfig.enviarRespondidas &&
                      config.enviarRespondidas))
                )"
                :rules="rulesArquivo"
                label="Selecione Arquivos de Evidência"
                v-model="props.item.arquivos"
              >
              </v-file-input>
            </v-form>
          </td>
          <td>
            <template
              v-if="
                podeEnviarPergunta1(props.item) &&
                !isDataLimiteVencida(props.item.dataLimiteEnvio) &&
                (isFullAdmin ||
                  !isSala ||
                  (isSala &&
                    JSON.parse(config.visualizaEixosIds || '[]').includes(
                      props.item.eixoId
                    )))
              "
            >
              <v-btn
                color="primary"
                class="ml-3"
                @click="checkCarregar(props.item)"
               v-if="!consultaSomenteLeitura(props.item)">
                <span>Carregar</span>
              </v-btn>
            </template>
          </td>
          <td v-if="props.item.evidencia && props.item.evidenciada === false">
            <app-modal-show-evidence
              :evidence="props.item.evidencia"
              :color="'primary'"
              :title="'Clique para exibir as características da evidência que deve ser apresentada'"
              v-if="props.item.evidencia.length > 0"
              :isHtml="true"
              @load="$emit('load')"
            >
            </app-modal-show-evidence>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="props">
        <tr
          class="complemento expanded"
          v-if="evidences && evidences.length > 0"
        >
          <td colspan="7" class="evidencias">
            <h1 class="titulo2">Evidências</h1>
            <div class="agrupEvidencias">
              <div
                class="nomeEvidencia"
                v-for="(ev, index) in evidences"
                :key="index"
                :style="
                  ev.nomeArquivo && ev.nomeArquivo.startsWith('DADOS_COMPLE_')
                    ? {
                        backgroundColor: 'rgb(88 132 253 / 8%)',
                        padding: '10px',
                        borderRadius: '4px',
                      }
                    : {}
                "
              >
                <div class="d-flex flex-column justify-center">
                  <div
                    @click="downloadEvidence(ev)"
                    class="evidencia-name"
                    :title="ev.nomeArquivo"
                  >
                    {{ ev.nomeArquivo }}
                  </div>

                  <div
                    v-if="
                      ev.nomeArquivo &&
                      ev.nomeArquivo.startsWith('DADOS_COMPLE_')
                    "
                    style="font-size: 20px; color: #2e7d32; font-weight: 500"
                  >
                    Declaração enviada
                    <template v-if="ev.dataInsercao">
                      em
                      {{
                        new Date(ev.dataInsercao).toLocaleDateString("pt-BR")
                      }}
                    </template>
                  </div>
                </div>

                <v-btn
                  outlined
                  color="error"
                  class="ml-3"
                  @click="perguntaDelete(ev)"
                  v-if="!consultaSomenteLeitura(props.item) && (podeExibirLixeiraEvidencia(props.item, ev))"
                >
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </div>
            </div>
          </td>
        </tr>
        <tr class="complemento" v-if="props.item.perguntaId == 3">
          <td colspan="7">
            <h1 class="titulo">Dados complementares obrigatórios</h1>

            <div>
              <!-- <div class="d-flex perguntas">
              <div class="_nome">
                Mínimo de horas por atendente informado no(s) arquivo(s)
                carregados acima
                <span v-if="!isParceiro"
                  >(incluindo as 04 horas mínimas de capacitação em Compras
                  Governamentais)
                </span>
              </div>
              <div>
                <v-text-field
                  label=""
                  type="number"
                  v-model="props.item.valorInformado"
                  outlined
                  placeholder="0"
                  hide-details="auto"
                 :disabled="consultaSomenteLeitura(props.item)"></v-text-field>
              </div>
            </div>
            <hr /> -->
              <div class="d-flex perguntas">
                <div class="_nome">
                  Quantidade de atendentes informada na
                  <strong>inscrição</strong>
                </div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="valorDiagnostico"
                    outlined
                    disabled
                    placeholder="0"
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </div>
              <hr />

              <div class="d-flex perguntas">
                <div class="_nome">
                  Nomes dos atendentes informados na inscrição
                </div>
                <div style="width: 50%">
                  <v-textarea
                    label=""
                    type="number"
                    v-model="valorNomeDiagnostico"
                    outlined
                    placeholder="0"
                    hide-details="auto"
                    disabled
                  ></v-textarea>
                </div>
              </div>
              <hr />

              <div class="d-flex perguntas">
                <div class="_nome">Quantidade atual de atendentes</div>
                <div>
                  <v-text-field
                    label=""
                    type="number"
                    v-model="props.item.atualizacaoAtendentes"
                    outlined
                    :disabled="isPrazoVencido(props.item, true)"
                    placeholder="0"
                    hide-details="auto"
                  ></v-text-field>
                </div>
              </div>
              <template>
                <hr />
                <div class="d-flex perguntas">
                  <div class="_nome">
                    <div>Declaração de alteração obrigatória se:</div>
                    <div>
                      Houve mudança na quantidade de atendentes OU A quantidade
                      foi mantida mas houve alteração do nome dos
                      atendentes responsáveis
                    </div>

                    <div class="mt-2">
                      Conforme o Regulamento, a Declaração de Alteração da
                      Equipe de Atendimento deverá ser inserida até
                      <span class="_nome">
                        <span v-if="props.item.dataLimiteEnvioDeclaracao">
                          {{
                            new Date(
                              props.item.dataLimiteEnvioDeclaracao
                            ).toLocaleString("pt-BR")
                          }}
                          - Horário de Brasília
                        </span>
                        <span v-else class="text-grey">Prazo não definido</span>
                      </span>
                      . O envio da declaração não exige o envio simultâneo dos
                      certificados, que poderão ser anexados até a data final
                      prevista no cronograma do Selo.
                    </div>
                  </div>
                  <div>
                    <v-file-input
                      v-if="!consultaSomenteLeitura(props.item) && (!isPrazoVencido(props.item, true))"
                      :accept="getFileAccept(props.item.perguntaId)"
                      :rules="rulesArquivo"
                      style="width: 300px"
                      label="Selecione o arquivo"
                      v-model="props.item.arquivosDados"
                      placeholder="Selecione o arquivo"
                      hide-details="auto"
                      outlined
                    >
                    </v-file-input>
                    <div
                      v-else
                      class="d-flex align-center"
                      style="color: #ff8f00; font-weight: 500; padding: 12px"
                    >
                      <v-icon color="#ff8f00" class="mr-2"
                        >mdi-alert-circle</v-icon
                      >
                      <span>Prazo da declaração expirado</span>
                    </div>
                    <v-alert
                      v-if="
                        evidences &&
                        evidences.find(
                          (ev) =>
                            ev.nomeArquivo &&
                            ev.nomeArquivo.startsWith('DADOS_COMPLE_')
                        )
                      "
                      type="success"
                      dense
                      outlined
                      class="mt-2 mb-0"
                      style="font-size: 20px"
                      icon="mdi-check-decagram"
                    >
                      <strong>Declaração enviada!</strong>
                      <div
                        v-if="
                          evidences.find(
                            (ev) =>
                              ev.nomeArquivo &&
                              ev.nomeArquivo.startsWith('DADOS_COMPLE_')
                          ).dataInsercao
                        "
                      >
                        Enviado em
                        <strong>{{
                          new Date(
                            evidences.find(
                              (ev) =>
                                ev.nomeArquivo &&
                                ev.nomeArquivo.startsWith("DADOS_COMPLE_")
                            ).dataInsercao
                          ).toLocaleDateString("pt-BR")
                        }}</strong>
                      </div>
                    </v-alert>
                  </div>
                </div>
              </template>

              <!-- Interface para alterar prazo da declaração -->

              <hr />
              <div class="d-flex perguntas align-center">
                <div class="_nome">
                  <div><strong>Prazo da Declaração:</strong></div>
                  <div v-if="props.item.dataLimiteEnvioDeclaracao">
                    {{
                      new Date(
                        props.item.dataLimiteEnvioDeclaracao
                      ).toLocaleString("pt-BR")
                    }}
                    - Horário de Brasília
                  </div>
                  <div v-else class="text-grey">Prazo não definido</div>
                </div>
                <template v-if="!consultaSomenteLeitura(props.item) && (podeAlterarPrazoEnvioEvidencias)">
                  <div>
                    <!-- Form para alterar data da declaração -->
                    <div
                      v-if="
                        itemAlteracaoDataDeclaracao ===
                        props.item.perguntaMunicipioId
                      "
                      class="d-flex align-center"
                      style="gap: 8px"
                    >
                      <v-text-field
                        type="date"
                        v-model="novaDataLimiteDeclaracao"
                        dense
                        outlined
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        type="time"
                        v-model="novaHoraLimiteDeclaracao"
                        dense
                        outlined
                        hide-details
                        style="width: 100px"
                      ></v-text-field>
                      <v-btn
                        small
                        color="success"
                        @click="alterarDataLimiteDeclaracao(props.item)"
                        :loading="salvandoNovaDataDeclaracao"
                        :disabled="
                          !novaDataLimiteDeclaracao || !novaHoraLimiteDeclaracao
                        "
                        class="mr-1"
                       v-if="!consultaSomenteLeitura(props.item)">
                        <v-icon small>mdi-check</v-icon>
                      </v-btn>
                      <v-btn
                        small
                        outlined
                        @click="itemAlteracaoDataDeclaracao = null"
                      >
                        <v-icon small>mdi-close</v-icon>
                      </v-btn>
                    </div>
                    <v-btn
                      v-else
                      small
                      outlined
                      color="orange"
                      @click="abrirAlteracaoDataDeclaracao(props.item)"
                     v-if="!consultaSomenteLeitura(props.item)">
                      <v-icon small class="mr-1">mdi-pencil</v-icon>
                      Alterar prazo declaração
                    </v-btn>
                  </div>
                </template>
              </div>
            </div>
          </td>
        </tr>
        <template
          v-if="
            isFullAdmin ||
            (!isPrazoVencido(props.item, false) &&
              groupsConfig.enviarRespondidas &&
              config.enviarRespondidas)
          "
        >
          <tr
            class="complemento expanded"
            v-if="props.item.perguntaId !== 3 ? props.item.temArquivo : true"
          >
            <td colspan="7">
              <div class="d-flex" style="justify-content: flex-end">
                <v-btn
                  color="primary"
                  class="ml-3"
                  @click="checkSalvarDados(props.item)"
                 v-if="!consultaSomenteLeitura(props.item)">
                  <span>Salvar</span>
                </v-btn>
                <v-btn
                  color="azulclarosc"
                  class="ml-3"
                  style="color: #fff"
                  @click="checarForm(props.item)"
                  v-if="!consultaSomenteLeitura(props.item) && (
                    evidences &&
                    evidences.length > 0 &&
                    evidences.find(
                      (item) => !item.nomeArquivo.includes('DADOS_COMPLE_')
                    )
                  )"
                >
                  <span>Salvar e enviar para análise</span>
                </v-btn>
              </div>
            </td>
          </tr>
        </template>
      </template>
      <template slot="no-data">
        <span> Nenhuma pergunta retornada </span>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import AppModalShowEvidence from "@/modules/diagnostic/components/ModalShowEvidence";
import { mapActions, mapGetters } from "vuex";
import { evidenceQuestionAPI } from "@/modules/evidence";
import Swal from "sweetalert2";
import { cityQuestionAPI } from "@/modules/city";
import { seloDiagnosticoRespostaAPI } from "@/modules/diagnosticoSelo/API/seloDiagnosticoRespostaAPI";
import { rulesFile } from "../utils";
import seloEvidenceReadScopeMixin from "@/utils/seloEvidenceReadScopeMixin";

export default {
  mixins: [seloEvidenceReadScopeMixin],
  components: {
    AppModalShowEvidence,
  },
  props: {
    visualizarPontosMedalha: { type: Boolean, required: true },
    perguntasRespondidas: { type: Array, required: true },
    headers: { type: Array, required: true },
    headersSemPontos: { type: Array, required: true },
    payload: { type: Object, Array: true },
    expanded: { type: Array, required: true },
    evidences: { type: Array, required: true },
    rulesArquivo: { type: Array, required: true },
  },
  data() {
    return {
      config: JSON.parse(localStorage.getItem("config")),
      groupsConfig: JSON.parse(localStorage.getItem("groupsConfig")),
      user: JSON.parse(localStorage.getItem("user")),
      visualizarComplemento: false,
      valorDiagnostico: 0,
      valorDiagnosticoPergunta3: null,
      origemAtendentesProdutividade: "Carregando...",
      consultaAtendentesId: 0,
      verComplemento: false,
      valorNomeDiagnostico: "",
      dataTerminoPergunta1: "2025-07-01T00:00:00",
      itemAlteracaoData: null,
      novaDataLimite: null,
      novaHoraLimite: null,
      salvandoNovaData: false,
      // Variáveis para alterar prazo da declaração
      itemAlteracaoDataDeclaracao: null,
      novaDataLimiteDeclaracao: null,
      novaHoraLimiteDeclaracao: null,
      salvandoNovaDataDeclaracao: false,
      // Cache para otimizar a geração de cores por data
      coresCache: {},
      sortBy: ["nome"],
      sortDesc: [false],
      // Paleta de cores fixa por data de prazo
      CORES_PRAZO: {
        "15/05": { bg: "#e3f2fd", border: "#1565c0", text: "#0d47a1" }, // Azul royal
        "15/06": { bg: "#f3e5f5", border: "#7b1fa2", text: "#4a148c" }, // Roxo
        "14/08": { bg: "#efebe9", border: "#6d4c41", text: "#3e2723" }, // Marrom couro
        "04/09": { bg: "#eceff1", border: "#455a64", text: "#263238" }, // Cinza ardósia
        outros: { bg: "#f5f5f5", border: "#757575", text: "#424242" }, // Cinza neutro
        expirado: { bg: "#fff3e0", border: "#ff8f00", text: "#e65100" }, // Laranja
      },
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    getFileAccept(perguntaId) {
      switch (perguntaId) {
        case 12:
        case 13:
          return ".jpg, .jpeg, .png, .gif, .bmp, .webp"; // Apenas fotos
        case 14:
          return ".mp4, .avi, .mov, .wmv, .mkv, .webm, .flv"; // Apenas vídeos
        default:
          return "application/pdf, application/vnd.ms-excel"; // Apenas PDF e Excel
      }
    },
    perguntasRespondidas3() {
      const municipioId = this.$route.params.id;
      const consultaId = ++this.consultaAtendentesId;
      this.valorDiagnosticoPergunta3 = null;
      this.origemAtendentesProdutividade = "Carregando...";
      return cityQuestionAPI
        .getAtendentesProdutividade(municipioId)
        .then(({ data }) => {
          if (this.$route.params.id !== municipioId || consultaId !== this.consultaAtendentesId) return;
          this.valorDiagnosticoPergunta3 = data.quantidade;
          this.origemAtendentesProdutividade = data.origem === "declaracao_aprovada"
            ? "Declaração aprovada"
            : data.origem === "inscricao" ? "Inscrição" : "Quantidade não informada";
        })
        .catch(() => {
          if (this.$route.params.id !== municipioId || consultaId !== this.consultaAtendentesId) return;
          this.origemAtendentesProdutividade = "Não foi possível consultar";
        });
    },
    podeEnviarPergunta1(item) {
      if (item.perguntaId !== 1 || !this.isSala || this.enviaPerguntaId1Selo)
        return true;

      // Verifica primeiro a data limite dinâmica se disponível
      if (item.dataLimiteEnvio) {
        const dataAtual = new Date();
        const dataLimite = new Date(item.dataLimiteEnvio);
        return dataAtual < dataLimite;
      }

      // Fallback para a data hardcoded original
      const dataAtual = new Date();
      const dataLimite = new Date("2025-07-01T00:00:00-03:00");
      return dataAtual < dataLimite;
    },
    checkCarregar(pergunta) {
      if (!this.isPrazoVencido(pergunta, true)) {
        pergunta.atualizacaoAtendentes = this.valorDiagnostico;
      }

      const pdfRules = rulesFile(
        pergunta.perguntaId,
        pergunta.quantidadeArquivo,
        pergunta.quantidadeArquivoDadosComplementares,
        this.valorDiagnostico,
        pergunta.atualizacaoAtendentes
      );

      if (!pergunta.arquivos || pergunta.arquivos.length == 0) {
        this.$notification.error("Não há evidências a serem enviadas!");
        return;
      } else if (pdfRules) {
        this.$notification.error(pdfRules);
        pergunta.arquivos = null;
      } else {
        pergunta.perguntaId == 3
          ? this.$emit("sendEvidences", pergunta, false, true)
          : this.$emit("sendEvidences", pergunta, false, false);
      }
    },
    downloadEvidence(evidence) {
      this.setLoading(true);
      evidenceQuestionAPI
        .download(evidence.perguntaEvidenciaId)
        .then(async (resp) => {
          const contentType = resp.headers["content-type"] || "";
          if (contentType.includes("application/json")) {
            const payload = JSON.parse(await resp.data.text());
            if (payload.url) {
              let link = document.createElement("a");
              link.href = payload.url;
              link.target = "_blank";
              link.click();
              this.setLoading(false);
              return;
            }
          }

          let blob = new Blob([resp.data], {
            type: contentType,
          });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();

          this.setLoading(false);
        })
        .catch((resp) => {
          console.log("resp: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao obter evidencia");
        });
    },
    perguntaAnalise(pergunta) {
      Swal.fire({
        title: "Enviar para análise!",
        text: `Ao enviar para análise, a evidência não poderá ser alterada. Deseja continuar?`,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("enviarAnalise", pergunta);
        } else {
          this.setLoading(false);
        }
      });
    },
    checkSalvarDados(pergunta) {
      if (pergunta.arquivosDados) {
        this.setLoading(true);
        cityQuestionAPI
          .getPergunta(pergunta.perguntaMunicipioId)
          .then((resp) => {
            pergunta.evidence = resp.data.evidencias;

            if (
              pergunta.arquivosDados &&
              pergunta.evidence.find((item) =>
                item.nomeArquivo.includes("DADOS_COMPLE_")
              )
            ) {
              Swal.fire({
                title: "Arquivo já existente",
                html: `
            Já existe um arquivo de dados complementares associado a essa pergunta.
            <div style="margin: 15px 0">Caso queira modifica-lo, poderá excluí-lo na seção <strong>Evidências</strong> acima de Dados Complementares.</div>
             <div>Arquivos de dados complementares começam por <strong>DADOS_COMPLE </strong></div>`,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Ok",
              });
              this.setLoading(false);
              return;
            } else {
              this.$emit("sendEvidences", pergunta, false, true);
            }
          })
          .catch((e) => {
            console.log("e: ", e);
            this.setLoading(false);
            this.$notification.error(e.message || "Erro ao obter pergunta");
          });
      } else {
        if (
          this.isPrazoVencido(pergunta, true) &&
          pergunta.quantidadeArquivoDadosComplementares < 1
        ) {
          pergunta.atualizacaoAtendentes = this.valorDiagnostico;
        }

        this.$emit("sendEvidences", pergunta, false, true);
      }
    },
    checarForm(pergunta) {
      if (pergunta.perguntaId == 13 && pergunta.quantidadeArquivo != 2) {
        this.$notification.error(
          "Para esta pergunta, é necessário enviar exatamente 2 evidências."
        );
        return;
      }

      pergunta.arquivos = null;
      this.setLoading(true);
      cityQuestionAPI
        .getPergunta(pergunta.perguntaMunicipioId)
        .then((resp) => {
          pergunta.evidence = resp.data.evidencias;
          const parseAtendentes = (valor) => {
            if (valor === null || valor === undefined) return null;

            const texto = String(valor).trim();
            if (!texto) return null;

            const numero = Number(texto);
            return Number.isNaN(numero) ? null : numero;
          };

          const valorDiagnosticoNormalizado = parseAtendentes(
            this.valorDiagnostico
          );
          const valorAtualizacaoNormalizado = parseAtendentes(
            pergunta.atualizacaoAtendentes
          );
          let houveMudancaQuantidadeAtendentes =
            valorDiagnosticoNormalizado !== null &&
            valorAtualizacaoNormalizado !== null &&
            valorDiagnosticoNormalizado !== valorAtualizacaoNormalizado;

          let hasArquivoDados =
            pergunta.evidence.find((item) =>
              item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivosDados;

          if (!this.isPrazoVencido(pergunta, true)) {
            hasArquivoDados = true;
            houveMudancaQuantidadeAtendentes = false;
            pergunta.atualizacaoAtendentes = this.valorDiagnostico;
          }

          let hasArquivos =
            pergunta.evidence.find(
              (item) => !item.nomeArquivo.includes("DADOS_COMPLE_")
            ) || pergunta.arquivos.length > 0;

          if (
            pergunta.atualizacaoAtendentes &&
            !!hasArquivoDados &&
            !!hasArquivos &&
            pergunta.perguntaId == 3
          ) {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          } else if (
            (!pergunta.atualizacaoAtendentes ||
              (!hasArquivoDados && houveMudancaQuantidadeAtendentes) ||
              !hasArquivos) &&
            pergunta.perguntaId == 3
          ) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `

            ${
              !pergunta.atualizacaoAtendentes
                ? '<div style="margin-top:20px">Quantidade atual de atendentes é obrigatória</div>'
                : ""
            }
            ${
              !hasArquivoDados && houveMudancaQuantidadeAtendentes
                ? `<div style="margin-top:20px">Arquivo de declaração da alteração da quantidade de atendentes é obrigatório</div>`
                : ""
            }
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else if (!hasArquivos && pergunta.perguntaId != 3) {
            Swal.fire({
              title: "Campos obrigatórios",
              html: `
             ${
               !hasArquivos
                 ? '<div style="margin-top:20px">É necessário ao menos uma evidência</div>'
                 : ""
             }
            `,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ok",
            });
            this.setLoading(false);
          } else {
            this.verComplemento = false;
            this.perguntaAnalise(pergunta);
          }
        })
        .catch((a) => {
          console.log("a: ", a);
          this.setLoading(false);
          this.$notification.error("Erro ao obter pergunta");
        });
    },
    getRespostaDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(26, this.$route.params.id)
        .then((resp) => {
          this.valorDiagnostico =
            resp.data && resp.data.length && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    getRespostaNomeDiagnostico() {
      this.setLoading(true);
      seloDiagnosticoRespostaAPI
        .getRespostaPergunta(27, this.$route.params.id)
        .then((resp) => {
          this.valorNomeDiagnostico = resp.data && resp.data[0].resposta;
        });
      this.setLoading(false);
    },
    perguntaDelete(evidence) {
      Swal.fire({
        title: `Excluir evidência`,
        text: `Deseja excluir a evidência ${evidence.nomeArquivo}? Esta operação não poderá ser desfeita. `,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Não",
        confirmButtonText: "Sim",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.deleteFile(evidence);
        }
      });
    },
    podeExibirLixeiraEvidencia(item, evidence) {
      const isDadosComplementares =
        evidence &&
        evidence.nomeArquivo &&
        evidence.nomeArquivo.startsWith("DADOS_COMPLE");

      if (
        isDadosComplementares &&
        (this.isPrazoVencido(item, false) || this.isPrazoVencido(item, true))
      ) {
        return false;
      }

      const podePelasRegrasAtuais =
        this.podeEnviarPergunta1(item) &&
        !this.isDataLimiteVencida(item.dataLimiteEnvio) &&
        (this.isFullAdmin ||
          !this.isSala ||
          (this.isSala &&
            JSON.parse(this.config.visualizaEixosIds || "[]").includes(
              item.eixoId
            )));

      if (!podePelasRegrasAtuais) return false;

      return true;
    },
    deleteFile(evidence) {
      this.setLoading(true);
      evidenceQuestionAPI
        .deleteEvidence(evidence.perguntaEvidenciaId)
        .then(() => {
          this.$emit("load");
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter deletar arquivo");
        });
    },
    formatarDataLimite(dataLimite) {
      if (!dataLimite) return "";

      const dataBrasilia = new Date(
        dataLimite.includes("Z") || /[+-]\d{2}:\d{2}$/.test(dataLimite)
          ? dataLimite
          : `${dataLimite}-03:00`
      );

      return dataBrasilia.toLocaleString("pt-BR", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "America/Sao_Paulo",
      });
    },
    isDataLimiteVencida(dataLimite) {
      if (!dataLimite) return false;

      const dataAtual = new Date();
      const dataLimiteDate = new Date(dataLimite);
      return dataAtual >= dataLimiteDate;
    },
    isDataLimiteDeclaracaoVencida(dataLimiteDeclaracao) {
      if (!dataLimiteDeclaracao) return false;

      const dataAtual = new Date();
      const dataLimiteDate = new Date(dataLimiteDeclaracao);
      return dataAtual >= dataLimiteDate;
    },
    isPrazoVencido(item, isDeclaracao = false) {
      if (isDeclaracao) {
        return this.isDataLimiteDeclaracaoVencida(
          item.dataLimiteEnvioDeclaracao
        );
      } else {
        return this.isDataLimiteVencida(item.dataLimiteEnvio);
      }
    },
    abrirAlteracaoData(item) {
      if (this.itemAlteracaoData === item.perguntaMunicipioId) {
        this.itemAlteracaoData = null;
      } else {
        this.itemAlteracaoData = item.perguntaMunicipioId;

        // Inicializa os campos com a data limite atual do item
        if (item.dataLimiteEnvio) {
          const dataLimite = new Date(item.dataLimiteEnvio);
          this.novaDataLimite = dataLimite.toISOString().split("T")[0];
          this.novaHoraLimite = dataLimite.toTimeString().slice(0, 5);
        }
      }
    },
    abrirAlteracaoDataDeclaracao(item) {
      if (this.itemAlteracaoDataDeclaracao === item.perguntaMunicipioId) {
        this.itemAlteracaoDataDeclaracao = null;
      } else {
        this.itemAlteracaoDataDeclaracao = item.perguntaMunicipioId;

        // Inicializa os campos com a data limite atual do item
        if (item.dataLimiteEnvioDeclaracao) {
          const dataLimite = new Date(item.dataLimiteEnvioDeclaracao);
          this.novaDataLimiteDeclaracao = dataLimite
            .toISOString()
            .split("T")[0];
          this.novaHoraLimiteDeclaracao = dataLimite.toTimeString().slice(0, 5);
        }
      }
    },
    // Método para gerar uma cor consistente baseada na data
    obterCorPorData(dataLimiteEnvio) {
      if (!dataLimiteEnvio) return null;

      const data = new Date(dataLimiteEnvio);
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      const chave = `${dia}/${mes}`;

      return this.CORES_PRAZO[chave] || this.CORES_PRAZO.outros;
    },

    // Método para obter a classe CSS da linha baseada no prazo
    getPrazoRowClass(dataLimiteEnvio) {
      if (!dataLimiteEnvio) return "";

      const isVencida = this.isDataLimiteVencida(dataLimiteEnvio);
      return isVencida ? "prazo-vencido" : "prazo-ativo";
    },

    // Método para obter o estilo inline da linha baseada no prazo
    getPrazoRowStyle(dataLimiteEnvio) {
      if (!dataLimiteEnvio) return {};

      const isVencida = this.isDataLimiteVencida(dataLimiteEnvio);
      const cor = this.obterCorPorData(dataLimiteEnvio);

      if (isVencida) {
        return {
          backgroundColor: "#fff3e0",
          borderLeft: "4px solid #ff8f00",
          color: "#e65100",
        };
      } else if (cor) {
        return {
          backgroundColor: cor.bg,
          borderLeft: `4px solid ${cor.border}`,
          color: cor.text,
        };
      }

      return {};
    },

    // Método para obter o estilo do header de prazo (aviso superior)
    getPrazoHeaderStyle(dataLimiteEnvio) {
      if (!dataLimiteEnvio) return {};

      const isVencida = this.isDataLimiteVencida(dataLimiteEnvio);
      const cor = this.obterCorPorData(dataLimiteEnvio);

      if (isVencida) {
        return {
          backgroundColor: "#fff3e0",
          color: "#e65100",
        };
      } else if (cor) {
        return {
          backgroundColor: cor.bg,
          color: cor.text,
        };
      }

      return {};
    },

    // Método para obter a cor do ícone baseada no prazo
    getPrazoIconColor(dataLimiteEnvio) {
      if (!dataLimiteEnvio) return "grey";

      const isVencida = this.isDataLimiteVencida(dataLimiteEnvio);
      const cor = this.obterCorPorData(dataLimiteEnvio);

      if (isVencida) {
        return "#ff8f00"; // Laranja para prazo expirado
      } else if (cor) {
        return cor.border; // Cor da borda para ativo
      }

      return "grey";
    },

    alterarDataLimite(item) {
      if (!this.novaDataLimite || !this.novaHoraLimite) {
        this.$notification.error("Data e horário são obrigatórios");
        return;
      }

      // Combina data e hora
      const novaDataCompleta = `${this.novaDataLimite}T${this.novaHoraLimite}:00`;

      this.salvandoNovaData = true;

      // Chama a API para desbloquear a data limite de envio
      cityQuestionAPI
        .desbloquearDataLimiteEnvio(
          item.perguntaMunicipioId,
          this.$route.params.id,
          novaDataCompleta
        )
        .then(() => {
          this.$notification.success("Data limite alterada com sucesso!");

          // Atualiza o valor local para refletir a mudança na interface
          item.dataLimiteEnvio = novaDataCompleta;

          this.$emit(
            "dataLimiteAlterada",
            item.perguntaMunicipioId,
            novaDataCompleta
          );
          this.itemAlteracaoData = null;
        })
        .catch((error) => {
          this.$notification.error("Erro ao alterar data limite");
          console.error(error);
        })
        .finally(() => {
          this.salvandoNovaData = false;
        });
    },
    alterarDataLimiteDeclaracao(item) {
      if (!this.novaDataLimiteDeclaracao || !this.novaHoraLimiteDeclaracao) {
        this.$notification.error("Data e horário são obrigatórios");
        return;
      }

      // Combina data e hora
      const novaDataCompleta = `${this.novaDataLimiteDeclaracao}T${this.novaHoraLimiteDeclaracao}:00`;

      this.salvandoNovaDataDeclaracao = true;

      // Chama a API para desbloquear a data limite de envio da declaração
      cityQuestionAPI
        .desbloquearDataLimiteEnvioDeclaracao(
          item.perguntaMunicipioId,
          this.$route.params.id,
          novaDataCompleta
        )
        .then(() => {
          this.$notification.success(
            "Data limite da declaração alterada com sucesso!"
          );

          // Atualiza o valor local para refletir a mudança na interface
          item.dataLimiteEnvioDeclaracao = novaDataCompleta;

          this.$emit(
            "dataLimiteDeclaracaoAlterada",
            item.perguntaMunicipioId,
            novaDataCompleta
          );
          this.itemAlteracaoDataDeclaracao = null;
        })
        .catch((error) => {
          this.$notification.error("Erro ao alterar data limite da declaração");
          console.error(error);
        })
        .finally(() => {
          this.salvandoNovaDataDeclaracao = false;
        });
    },
  },
  mounted() {
    this.getRespostaDiagnostico();
    this.getRespostaNomeDiagnostico();
    this.perguntasRespondidas3();
  },

  watch: {
    "$route.params.id"() { this.perguntasRespondidas3(); },
    perguntasRespondidas() { this.perguntasRespondidas3(); },
  },
  computed: {
    ...mapGetters([
      "isAdmin",
      "isConsultorCondutorMunicipio",
      "isConsultorEspecialistaMunicipio",
      "isADMunicipio",
      "isAuthenticated",
      "uf",
      "logo",
      "isSala",
      "isAnalista",
      "isParceiro",
      "isFullAdmin",
    ]),
    perguntasRespondidas1() {
      const a = this.perguntasRespondidas.map((pergunta) => {
        console.log("pergunta: ", pergunta);
        if (
          this.isPrazoVencido(pergunta, true) &&
          pergunta.quantidadeArquivoDadosComplementares < 1
        ) {
          pergunta.atualizacaoAtendentes = this.valorDiagnostico;
        }

        return pergunta;
      });
      return a;
    },
    enviaPerguntaId1Selo() {
      return (
        this.isFullAdmin ||
        (this.groupsConfig &&
          this.groupsConfig.enviaPerguntaId1Selo &&
          this.config &&
          this.config.enviaPerguntaId1Selo)
      );
    },

    podeAlterarPrazoEnvioEvidencias() {
      return (
        this.isFullAdmin ||
        (this.groupsConfig &&
          this.groupsConfig.podeAlterarPrazoEnvioEvidencias &&
          this.config &&
          this.config.podeAlterarPrazoEnvioEvidencias)
      );
    },
  },
};
</script>
<style>
.respo .complemento .v-input__control {
  background: #fff;
}

.pergunta3 .v-file-input__text {
  color: #fff !important;
}
.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}

.pergunta3 .v-text-field .v-label {
  color: #f5f5f5 !important;
}

.pergunta3 {
  background: #2d6189 !important;
  color: #fff;
}
.pergunta3:hover {
  background: #225a85 !important;
  color: #fff;
}
.respo .complemento {
  background: #f5f5f5;
}

/* Estilos para linhas com prazo */
.prazo-ativo {
  font-weight: 500;
}

.prazo-vencido {
  font-weight: 500;
  opacity: 0.9;
}

.prazo-ativo:hover {
  opacity: 0.8;
}

.prazo-vencido:hover {
  opacity: 1;
}

/* Garantir que o texto seja legível nas linhas coloridas */
.prazo-ativo td,
.prazo-vencido td {
  font-weight: inherit;
}

/* Melhorar o visual da linha de data limite existente para complementar o novo estilo */
.data-limite-row td {
  background: transparent !important;
}

/* Garantir que o aviso de prazo tenha visual integrado com a linha da tabela */
.data-limite-row .rounded {
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* Estilos para a legenda de cores */
.v-card {
  border: 1px solid #e0e0e0 !important;
}

.v-card .text-body-2 {
  color: #424242;
}

.v-card .text-caption {
  color: #616161;
  font-size: 12px;
}
</style>
<style scoped lang="scss">
.evidencias {
  padding: 10px 30px !important;
  .titulo2 {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .nomeEvidencia {
    cursor: pointer;
    color: #2d6189;
    font-weight: bold;
    display: flex;
    align-items: center;
  }

  .nomeEvidencia:not(:last-of-type) {
    border-right: 1px solid #dfdfdf;
    padding-right: 20px;
  }

  .agrupEvidencias {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
    row-gap: 20px;
  }
}

.complemento td {
  padding: 10px 30px !important;
}
.titulo {
  font-size: 20px;
  margin: 1rem 0;
}
.perguntas {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0;

  ._nome {
    max-width: 70%;
  }
}

.evidencia-name {
  cursor: pointer;
  font-size: 12px;
  max-width: 300px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}

.evidencia-name:hover {
  text-decoration: underline;
}
</style>
